import styled from "styled-components/macro";
import {
  goodColor,
  untaggedColor,
  unknownAdjustmentColor,
  brightBlue,
  buttonDisabled,
  buttonTextDisabled,
  lightGrey,
  darkGrey,
} from "../../../../../constants/colors";
import { FONT_SIZE_SMALL } from "../../../../../constants/constants";

export const UnknownMinutesAdjustmentStyles = styled.div<{
  $isAboveOrEqualToMinuteLimit: boolean;
}>`
  margin-top: 2em;

  form {
    display: flex;
    flex-direction: column;
  }

  .unknownMinutesLabel {
    display: flex;

    .btnLabel {
      font-size: ${FONT_SIZE_SMALL}px;
      color: ${unknownAdjustmentColor};
    }

    svg {
      fill: ${unknownAdjustmentColor};
    }
  }

  .alert {
    font-size: ${FONT_SIZE_SMALL}px;
    margin-left: 10px;
    color: ${props =>
      props.$isAboveOrEqualToMinuteLimit ? goodColor : untaggedColor};
  }
`;

export const EditSubmitFormStyles = styled.div<{
  $isDarkMode: boolean;
  $isEditable: boolean;
  $isSubmitDisabled: boolean;
}>`
  display: flex;
  justify-content: flex-end;
  padding: 1em;
  background-color: ${({ $isDarkMode }) =>
    $isDarkMode ? darkGrey : lightGrey};

  button {
    margin-right: 2em;
  }

  button[type="button"] {
    background-color: ${props => (props.$isEditable ? "none" : brightBlue)};
    color: ${props => (props.$isEditable ? brightBlue : "white")};
  }

  button[type="submit"] {
    background-color: ${props =>
      props.$isSubmitDisabled ? buttonDisabled : brightBlue};
    color: ${props => (props.$isSubmitDisabled ? buttonTextDisabled : "white")};
    position: relative;
    width: 10em;
  }
  .spinnerWrapper {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
`;
